exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Estilos específicos para o componente Cancelar Produto Agregado */\n\n.cancelarProduto {\n  background-image: url(\"/bfportalcli/assets/img/ico-close-black.svg\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 30px;\n  height: 30px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n\n/* Card do produto já solicitado para cancelamento */\n.btn.card2.solicitado {\n  position: relative;\n  opacity: 0.6;\n  cursor: not-allowed;\n  -webkit-filter: grayscale(60%);\n          filter: grayscale(60%);\n}\n\n.badge-solicitado {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: #4caf50;\n  font-size: 0.75rem;\n  font-weight: bold;\n  z-index: 1;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-cancelarproduto-cli/cancelar-produto-agregado.component.css
// module id = ../../../../../src/app/bf-cancelarproduto-cli/cancelar-produto-agregado.component.css
// module chunks = main